import { ROUTER_NAMES } from 'router/routerNames'

import { UserRole } from 'models/user'

import { ReactComponent as CalculatorIcon } from 'assets/images/svg/calculator.svg'
import { ReactComponent as ContactClassicIcon } from 'assets/images/svg/contact-classic.svg'
import { ReactComponent as ContactIcon } from 'assets/images/svg/contact.svg'
import { ReactComponent as IssuanceIcon } from 'assets/images/svg/issuance.svg'
import { ReactComponent as LayersIcon } from 'assets/images/svg/layers.svg'
import { ReactComponent as MapIcon } from 'assets/images/svg/map.svg'
import { ReactComponent as PortraitIcon } from 'assets/images/svg/portrait.svg'
import { ReactComponent as UsersIcon } from 'assets/images/svg/users.svg'

export const NAV_LIST = [
  {
    title: 'Заявки',
    path: ROUTER_NAMES.APPLICATIONS,
    icon: <LayersIcon />,
    roles: [
      UserRole.Administrator,
      UserRole.ONLY_VIEW,
      UserRole.Controller,
      UserRole.SuperController,
      UserRole.Manager,
    ],
  },
  {
    title: 'Пользователи',
    path: ROUTER_NAMES.USERS,
    icon: <UsersIcon />,
    roles: [
      UserRole.Administrator,
      UserRole.ONLY_VIEW,
      UserRole.AdministratorCIB,
    ],
  },
  {
    title: 'Супервайзеры',
    path: ROUTER_NAMES.SUPERVISORS,
    icon: <PortraitIcon />,
    roles: [UserRole.Administrator, UserRole.ONLY_VIEW],
  },
  {
    title: 'Привлеченцы',
    path: ROUTER_NAMES.ATTRACTORS,
    icon: <PortraitIcon />,
    roles: [UserRole.SuperController],
  },
  {
    title: 'Калькулятор',
    path: ROUTER_NAMES.CALCULATORS,
    icon: <CalculatorIcon />,
    roles: [UserRole.Administrator],
  },
  {
    title: 'Логистика',
    path: ROUTER_NAMES.LOGISTIC,
    icon: <MapIcon />,
    roles: [
      UserRole.Administrator,
      UserRole.ONLY_VIEW,
      UserRole.ControllerUKC,
      UserRole.Author,
      UserRole.Executor,
    ],
  },
  {
    title: 'Диспетчер',
    path: ROUTER_NAMES.NEW,
    icon: <MapIcon />,
    reloadDocument: true,
    roles: [
      UserRole.Administrator,
      UserRole.ONLY_VIEW,
      UserRole.ControllerUKC,
      UserRole.Author,
      UserRole.Executor,
    ],
  },
  {
    title: 'Выдача призов',
    path: ROUTER_NAMES.ISSUANCE,
    icon: <IssuanceIcon />,
    reloadDocument: true,
    roles: [
      UserRole.Administrator,
      UserRole.ONLY_VIEW,
      UserRole.ControllerUKC,
      UserRole.Author,
      UserRole.Executor,
    ],
  },
  {
    title: 'КЦ',
    path: ROUTER_NAMES.CONTACT_CENTER,
    icon: <ContactIcon />,
    roles: [
      UserRole.Administrator,
      UserRole.ONLY_VIEW,
      UserRole.Specialist,
      UserRole.ControllerUKC,
    ],
  },
  {
    title: 'Филиалы',
    path: ROUTER_NAMES.FILIAL,
    icon: <ContactClassicIcon />,
    roles: [
      UserRole.Administrator,
      UserRole.ONLY_VIEW,
      UserRole.Specialist,
      UserRole.ControllerUKC,
    ],
  },
  {
    title: 'Территории',
    path: ROUTER_NAMES.NEW_TERRITORIES,
    icon: <MapIcon />,
    reloadDocument: true,
    roles: [UserRole.Supervisor],
  },
]
